import { render, staticRenderFns } from "./AllReinstatementSubmissions.vue?vue&type=template&id=c2ef2096&scoped=true&"
import script from "./AllReinstatementSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllReinstatementSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllReinstatementSubmissions.vue?vue&type=style&index=0&id=c2ef2096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ef2096",
  null
  
)

export default component.exports